import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/img/kofgym.png'


const _hoisted_1 = {
  id: "footer",
  style: {"border-top":"1px solid #48a1de"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { style: {"color":"#48a1de"} }, "聯繫我們：", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, " ", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 2022 by Cheese Burger Co. Ltd. All right reserved ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { inject, onMounted } from "vue";
import { useRouter } from "vue-router";

import { Row, Col } from "ant-design-vue";
import {
  MailOutlined,
  TagOutlined,
  PhoneOutlined,
} from "@ant-design/icons-vue";

import { cartStore } from "@/store/Store";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const axios = inject("axios"); //1.aixos的引入
const router = useRouter();

let mycart = cartStore();
let { oursinformation, linkinformation } = storeToRefs(mycart);

const jump = (page: any) => {
  router.push(`/${page}`);
  // window.location.href = "#/" + page;
};
const open = (e) => {
  // router.push("/detall?id=" + e);
  // location.reload();
  window.open("#/detall?id=" + e, "_blank");
};
// onMounted(() => {
//   console.log(linkinformation.value);
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Row), {
      align: "top",
      class: "bottom-area"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), {
          span: 22,
          offset: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Row), { align: "top" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Col), {
                  lg: 6,
                  md: 24,
                  xs: 24,
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _imports_0,
                      style: {"width":"200px","height":"200px"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (jump('')))
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Col), {
                  lg: 12,
                  md: 24,
                  xs: 24,
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Row), { justify: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Col), {
                          xl: 20,
                          md: 12,
                          xs: 22,
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Row), {
                              gutter: [16, 16],
                              justify: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Col), { span: 24 }, {
                                  default: _withCtx(() => [
                                    _hoisted_2
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(Col), {
                                  span: 24,
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Row), { gutter: 16 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Col), {
                                          align: "center",
                                          xs: 3,
                                          md: 2,
                                          style: {"margin-right":"15px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(PhoneOutlined), { style: {"font-size":"25px","color":"#48a1de"} })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(Col), {
                                          span: 20,
                                          align: "left"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("a", null, _toDisplayString(_unref(oursinformation).contact_tel), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(Col), {
                                  span: 24,
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Row), { gutter: 16 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Col), {
                                          align: "center",
                                          xs: 3,
                                          md: 2,
                                          style: {"margin-right":"15px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(MailOutlined), { style: {"font-size":"25px","color":"#48a1de"} })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(Col), {
                                          span: 20,
                                          align: "left"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("a", null, _toDisplayString(_unref(oursinformation).contact_email), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(Col), {
                                  span: 24,
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Row), {
                                      gutter: 16,
                                      align: "middle"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Col), {
                                          align: "center",
                                          xs: 3,
                                          md: 2,
                                          style: {"margin-right":"15px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(TagOutlined), { style: {"font-size":"25px","color":"#48a1de"} })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(Col), {
                                          span: 20,
                                          align: "left"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("a", null, _toDisplayString(_unref(oursinformation).contact_address), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Col), {
                  lg: 6,
                  md: 24,
                  xs: 24,
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Row), { justify: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Col), {
                          xl: 20,
                          md: 12,
                          xs: 22,
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Row), {
                              gutter: [16, 16],
                              justify: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Col), { span: 24 }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linkinformation), (item, index) => {
                                  return (_openBlock(), _createBlock(_unref(Col), {
                                    span: 24,
                                    align: "center",
                                    key: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (open(item.id)),
                                        target: "_blank"
                                      }, _toDisplayString(item.name), 9, _hoisted_4)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), {
          span: 22,
          offset: 1,
          align: "center",
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})